module.exports = __webpack_public_path__ + "static/img/main-bottom.e1b50b5a.png";